import React, { useEffect } from "react";
import {
  useNavigate,
  useLocation,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import ProcurementDashboard from "../procurement/dashboard/ProcurementDashboard";
import FmsRoutes from "../../fms/routes/FmsRoutes";
import TransportRoutes from "../../transport/routes/TransportRoutes";

/*
-------------------------------------------------------
TAB CONFIG
-------------------------------------------------------
*/
const DASHBOARD_TABS = [
  {
    key: "procurement",
    label: "Procurement",
    tabPath: "/ppe/dashboard/procurement",
    modulePath: "/ppe/dashboard/procurement"
  },
  {
    key: "fms",
    label: "FMS",
    tabPath: "/ppe/dashboard/fms",
    modulePath: "/ppe/dashboard/fms/dashboard"
  },
  {
    key: "transport",
    label: "Transport",
    tabPath: "/ppe/dashboard/transport",
    modulePath: "/ppe/dashboard/transport/dashboard"
  }
];

export default function PPEDashboard() {

  const navigate = useNavigate();
  const location = useLocation();

  // ---------------------------------------------------
  // AUTO OPEN LAST TAB OR FIRST TAB
  // ---------------------------------------------------
  useEffect(() => {

    if (location.pathname === "/ppe/dashboard") {

      const lastTab =
        localStorage.getItem("ppe_active_dashboard");

      const defaultPath =
        lastTab || DASHBOARD_TABS[0].modulePath;

      navigate(defaultPath, { replace: true });
    }

  }, [location.pathname, navigate]);

  // ---------------------------------------------------
  // ACTIVE TAB CHECK
  // ---------------------------------------------------
  const isActive = (tab) =>
    location.pathname.startsWith(tab.tabPath);

  // ---------------------------------------------------
  // TAB CLICK
  // ---------------------------------------------------
  const openTab = (tab) => {

    localStorage.setItem(
      "ppe_active_dashboard",
      tab.modulePath
    );

    navigate(tab.modulePath);
  };

  return (
    <div>

  {/* ================= INLINE CSS ================= */}
  <style>{`

    /* ===== TAB WRAPPER ===== */
    .ppe-dashboard-tabs {
      background: #e5e7eb;
      padding: 12px 12px 0 12px;
      border-radius: 12px;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    /* ===== TAB ROW ===== */
    .ppe-tab-container {
      display: flex;
      gap: 6px;
      align-items: flex-end;
    }

    /* ===== BASE TAB ===== */
    .ppe-tab {
      position: relative;
      border: none;
      background: #d1d5db;
      padding: 10px 22px;
      border-radius: 12px 12px 0 0;
      font-weight: 500;
      color: #374151;
      cursor: pointer;
      transition: all 0.25s ease;
    }

    .ppe-tab:hover {
      background: #cbd5e1;
    }

    /* ===== ACTIVE TAB ===== */
    .ppe-tab.active {
      background: linear-gradient(
        90deg,
        #6366f1,
        #4f46e5
      );
      color: #fff;
      z-index: 2;
    }

    /* ===== CURVED CUT EFFECT ===== */
    .ppe-tab.active::after {
      content: "";
      position: absolute;
      right: -14px;
      bottom: 0;
      width: 28px;
      height: 28px;
      background: #e5e7eb;
      border-bottom-left-radius: 20px;
    }

    /* ===== CONTENT AREA (attached look) ===== */
    .ppe-content-area {
      background: #ffffff;
      padding: 16px;
      border-radius: 0 12px 12px 12px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.06);
      margin-top: 0;
    }

  `}</style>

  {/* TAB BAR */}
  <div className="ppe-dashboard-tabs">
    <div className="ppe-tab-container">

      {DASHBOARD_TABS.map(tab => (
        <button
          key={tab.key}
          className={`ppe-tab ${
            isActive(tab) ? "active" : ""
          }`}
          onClick={() => openTab(tab)}
        >
          {tab.label}
        </button>
      ))}

    </div>
  </div>

  {/* DASHBOARD CONTENT AREA */}
  <div className="ppe-content-area">

    <Routes>

      {/* PROCUREMENT */}
      <Route
        path="procurement"
        element={<ProcurementDashboard />}
      />

      {/* FMS MODULE */}
      <Route
        path="fms/*"
        element={<FmsRoutes />}
      />

      {/* TRANSPORT MODULE */}
      <Route
        path="transport/*"
        element={<TransportRoutes />}
      />

      {/* SAFETY FALLBACK */}
      <Route
        path="*"
        element={
          <Navigate
            to={DASHBOARD_TABS[0].modulePath}
            replace
          />
        }
      />

    </Routes>

  </div>

</div>
);
}